let fleetFullscreenOverlaySnapshot = {
  isActive: false,
  token: 0,
};

const fleetFullscreenOverlayListeners = new Set();

function emitFleetFullscreenOverlayChange() {
  fleetFullscreenOverlayListeners.forEach((listener) => {
    try {
      listener();
    } catch {
      // Ignore listener errors to keep overlay propagation stable.
    }
  });
}

export function getFleetFullscreenOverlaySnapshot() {
  return fleetFullscreenOverlaySnapshot;
}

export function subscribeFleetFullscreenOverlay(listener) {
  if (typeof listener !== "function") {
    return () => {};
  }

  fleetFullscreenOverlayListeners.add(listener);
  return () => {
    fleetFullscreenOverlayListeners.delete(listener);
  };
}

export function setFleetFullscreenOverlayActive(isActive) {
  const nextIsActive = isActive === true;
  if (fleetFullscreenOverlaySnapshot.isActive === nextIsActive) {
    return false;
  }

  fleetFullscreenOverlaySnapshot = {
    isActive: nextIsActive,
    token: fleetFullscreenOverlaySnapshot.token + 1,
  };
  emitFleetFullscreenOverlayChange();
  return true;
}